var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetDiagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7987_58285)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13.637,
    r: 1,
    fill: "#264C86",
    stroke: "#264C86"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.13696,
    r: 1,
    fill: "#264C86",
    stroke: "#264C86"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8.63696,
    r: 1,
    fill: "#264C86",
    stroke: "#264C86"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.125,
    cy: 8.76196,
    r: 2.125,
    fill: "#264C86",
    stroke: "#264C86"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 8.63696,
    x2: 14.5059,
    y2: 8.63696,
    stroke: "#264C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.137H9C8.72386 14.137 8.5 13.9131 8.5 13.637V2.63696C8.5 2.36082 8.72386 2.13696 9 2.13696H12.7857",
    stroke: "#264C86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7987_58285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.136963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetDiagramIcon);
export default __webpack_public_path__ + "static/media/net_diagram_icon.9351ecb92169cd817eabd16d112f8818.svg";
export { ForwardRef as ReactComponent };